module.exports = ({Api})=>

  lulusAreSelected:(lulus)->
    lulus = [lulus] if !Array.isArray(lulus)
    type: 'LULUS_SELECT',
    selected: JSON.parse(JSON.stringify(lulus))

  lulusAreEditing:(bool)->
    type: 'LULUS_ARE_EDITING',
    value:bool

  lulusAdding:(bool)->
    type: 'LULUS_ADDING',
    value: bool

  lulusSelectedAreLoading:(bool)->
    type: 'LULUS_SELECTED_ARE_LOADING',
    value: bool 

  lulusSelectedUpdated:(id, field, value)->
    type: 'LULUS_SELECT_UPDATE',
    id: id,
    field: field,
    value: value 

  lulusLoad: ->
    Api.Load({
      url: "/duocms/api/lulu/printjobs"
      isLoading: (bool)-> type: 'LULUS_ARE_LOADING',value: bool
      onLoad: (items)->
        console.log("loaded",items)
        type: 'LULUS_LOAD_SUCCESS', items: items
    })

  lulusLoadSelected:(url)->
    Api.Load({
      url: url
      isLoading: this.lulusSelectedAreLoading
      onLoad: this.lulusAreSelected
    })

  lulusAreSaving:(bool)->
    type: 'LULUS_ARE_SAVING'
    value:bool 

  luluSavedSuccess:(items)->
    type: 'LULU_SAVED_SUCCESS',
    items: items

  lulusSaveSelected:(lulu, msg)->
    Api.Save({
      isSaving: @lulusAreSaving,
      onSaved: @luluSavedSuccess,
      url: "/duocms/api/lulu/printjobs",
      data:lulu,
      successLulu:msg
    })

  lulusSelectedDelete:(lulus)->
    ids = lulus.map((lulu)=> lulu.id) || []
    Api.Delete({
      url: "/duocms/api/lulu/printjobs",
      ids: ids
      onDeleted: @luluDeletedSuccess,
    })

  luluDeletedSuccess:(id)->
    type: 'LULU_DELETED_SUCCESS',
    id: id

  lulusSetSearchTerm:(term)->
    type: 'LULUS_SEARCH_TERM',
    value: term